export default "__VITE_ASSET__2bf07f38__"